import { ThroughputTime } from './throughput-time';
import { AverageThroughputTimeDTO } from '../interfaces/average-throughput-time.interface';

export class AverageThroughputTime {
  public totalAvgThroughputTime: number;
  public avarageThroughputTime: Array<ThroughputTime>;

  public static fromDTO(
    averageThroughputTime: AverageThroughputTimeDTO
  ): AverageThroughputTime {
    const average: AverageThroughputTime = new AverageThroughputTime();
    average.totalAvgThroughputTime =
      averageThroughputTime.totalAvgThroughputTime;
    average.avarageThroughputTime = averageThroughputTime.avgThroughputTime;
    return average;
  }
}
